import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=46413640&"
import script from "./Install.vue?vue&type=script&lang=js&"
export * from "./Install.vue?vue&type=script&lang=js&"
import style0 from "./Install.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports